export function normalizeCustomerAppPublicUrl(url: string) {
  const trimmedUrl = url.trim().replace(/\/+$/, "");

  if (/^https?:\/\//i.test(trimmedUrl)) {
    return trimmedUrl;
  }

  return `https://${trimmedUrl}`;
}

export function getDigitalReceiptUrl(
  customerAppPublicUrl: string,
  paymentGuid: string,
) {
  return `${normalizeCustomerAppPublicUrl(customerAppPublicUrl)}/payments/${paymentGuid}`;
}
